import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-deals.reducer';

export const UserDealsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userDealsEntity = useAppSelector(state => state.userDeals.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userDealsDetailsHeading">
          <Translate contentKey="tycheApp.userDeals.detail.title">UserDeals</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tycheApp.userDeals.id">Id</Translate>
            </span>
          </dt>
          <dd>{userDealsEntity.id}</dd>
          <dt>
            <span id="customerId">
              <Translate contentKey="tycheApp.userDeals.customerId">Customer Id</Translate>
            </span>
          </dt>
          <dd>{userDealsEntity.customerId}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tycheApp.userDeals.status">Status</Translate>
            </span>
          </dt>
          <dd>{userDealsEntity.status}</dd>
          <dt>
            <span id="createdAt">
              <Translate contentKey="tycheApp.userDeals.createdAt">Created At</Translate>
            </span>
          </dt>
          <dd>
            {userDealsEntity.createdAt ? <TextFormat value={userDealsEntity.createdAt} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="updatedAt">
              <Translate contentKey="tycheApp.userDeals.updatedAt">Updated At</Translate>
            </span>
          </dt>
          <dd>
            {userDealsEntity.updatedAt ? <TextFormat value={userDealsEntity.updatedAt} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="expired">
              <Translate contentKey="tycheApp.userDeals.expired">Expired</Translate>
            </span>
          </dt>
          <dd>{userDealsEntity.expired ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tycheApp.userDeals.customer">Customer</Translate>
          </dt>
          <dd>{userDealsEntity.customer ? userDealsEntity.customer.id : ''}</dd>
          <dt>
            <Translate contentKey="tycheApp.userDeals.deal">Deal</Translate>
          </dt>
          <dd>{userDealsEntity.deal ? userDealsEntity.deal.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-deals" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-deals/${userDealsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserDealsDetail;
